<script setup>
import { useDetailsReport } from '#/detailsReport/useDetailsReport'
const { version } = useDetailsReport()
defineProps({ label: String, tooltipText: String })
</script>

<template lang="pug">
.infoLineTooltipContainer
  .infoLineContainer(style="max-width: 386px")
    .infoLineTitle {{ label }}
    .infoLineTooltipBody.row
      .infoLineBody
        div {{ tooltipText }}
        .tooltipBottom(v-if="version === 1")
          .greyCircle
          .circleTitle Bestehend
          .greenCircle
          .circleTitle Potenzial
      .imgContainer
        img(v-if="label === 'Gebäudevolumen'" src="https://raumpionierestorage.blob.core.windows.net/images/gebaudevolumenTooltip.png" style="width: 135px; height: 135px")
        img(v-else-if="label === 'Geschosse'" src="https://raumpionierestorage.blob.core.windows.net/images/geschosseTooltip.png" style="width: 135px; height: 135px")
        img(v-else-if="label === 'Fassadenhöhe' && version === 1" src="https://raumpionierestorage.blob.core.windows.net/images/fassadenhoheTooltip.png" style="width: 135px; height: 135px")
        img(v-else-if="label === 'Vollgeschosse'" src="https://raumpionierestorage.blob.core.windows.net/images/vollgeschosse.png" style="width: 135px; height: 135px")
        img(v-else-if="label === 'Fassadenhöhe' && version === 2" src="https://raumpionierestorage.blob.core.windows.net/images/fassadenhoehe.png" style="width: 135px; height: 135px")
        .img-bottom(v-if="version === 2")
          .greenCircle
          .img-bottom-label {{ label }}
</template>

<style scoped lang="sass">
.infoLineTooltipContainer
  margin-top: 20px
  background: #FFFFFF
  .infoLineContainer
    background: #FFFFFF
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25)
    border-radius: 4px
    z-index: 1
    padding: 20px
    .infoLineTitle
      font-weight: 700
      font-size: 12px
      line-height: 150%
      letter-spacing: 0.03em
      color: #007BFF
    .infoLineTooltipBody
      display: flex
      flex-direction: row
      flex-wrap: nowrap
      width: 100%
      .imgContainer
        width: 135px
      .infoLineBody
        white-space: pre-line
        margin-top: 10px
        font-weight: 400
        font-size: 12px
        line-height: 150%
        color: #2F3849
        width: 200px
.tooltipBottom
  display: flex
  flex-direction: row
  margin-top: 20px
  .greyCircle
    margin-right: 10px
    width: 16px
    height: 16px
    border-radius: 100px
    background: #969696
.img-bottom
  display: flex
  flex-direction: row
  align-items: flex-end
  margin-top: -10px
  margin-left: 5px
  .img-bottom-label
    font-weight: 500
    font-size: 12px
    line-height: 130%
    color: #626C85
    margin-left: 10px

.greenCircle
  margin-right: 10px
  width: 16px
  height: 16px
  border-radius: 100px
  background: #5FEFC0
.circleTitle
  margin-right: 10px
  font-weight: 500
  font-size: 12px
  line-height: 130%
  color: #626C85
</style>
